import { Link } from "react-router-dom";
import '../styles/terms.css';
import React, { useEffect, useState } from 'react';
import HeaderFFF from '../components/HeaderFFF'
import Header from '../components/Header'
import Footer from "../components/Footer";

export default function Privacy() {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);
    
        useEffect(() => {
            const handleResize = () => {
                setIsMobile(window.innerWidth <= 991);
            };
    
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, []);
    
        return(
            <>
            {isMobile ? <Header /> : <HeaderFFF />}
                <div className="privacy-box">
                    <h2>Privacy Policy</h2>
                    <span id="privacy-text">
                        Thank you for visiting our website. This policy establishes how we will handle information we learn about you from your visit to our site. We collect no personally identifiable information or identifiable business information about you when you visit our website unless you choose to provide that information to us.
                        <br/><br/>
                        <h3>Automatic Collections</h3>
                        For each HTTP request received (what your web browser generates when you request a page or part of a page from a website), we collect and store only the following information:
                            <ul>
                                <li>date and time</li>
                                <li>originating IP address</li>
                                <li>type of browser and operating system used (if provided by the browser)</li>
                                <li>URL of the referring page (if provided by the browser)</li>
                                <li>object requested</li>
                                <li>completion status of the request</li>
                                <li>pages visited</li>
                            </ul>
                            <h3>Use of Information</h3>
                            When you provide information through this website, we will only use that information to respond to direct inquiries or to measure traffic to help us make our website more useful to visitors.<br/><br/>
                            <h3>Voluntary Information Collected</h3>
                            When you register for e-newsletters or alerts, or when you attempt to access a secure extranet page, we ask for identification such as your name, email address and/or company name. If you're sending a resume to us, we ask for your name, email address, home address, and general inquiries into your professional aspirations. We do not provide or sell any of this information to third parties.
                            <br/><br/><h3>Cookies</h3>
                            We do not use "persistent cookies" or any persistent tracking methods to collect personally identifiable information or identifiable business information about visitors to our website.
                            <br/><br/><h3>Policy Changes</h3>
                            We reserve the right to change our policy regarding cookies and the collection of information from visitors at any time without advance notice. Should any new policy go into effect, we will post the changes on this website and the new policy will only apply to information collected thereafter. Any such policy changes will permit visitors to "opt out".
                    </span>
                </div>
            <Footer />
        </>
    );
}